<template>
  <header :class="[
    'd-flex card-header text-white p-0',
    showButton ? 'justify-content-between pr-0 bg-dark' : 'py-1 px-2 form-control-sm border-bottom border-gray bg-header']">
      <slot name="header"><h5 class="p-2-5 mb-0">{{ headerTitle }}</h5></slot>
      <b-button v-if="showButton && buttonText !== 'h-only'" variant="dark" size="md" class="border-left border-muted w-200" @click="buttonPress()">{{ btnTxt }}</b-button>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    title: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headerTitle: this.title,
      btnTxt: this.buttonText,
    };
  },
  computed: {
    showButton() {
      return this.buttonText !== '';
    },
  },
  methods: {
    buttonPress() {
      this.$emit('button-pressed');
    }
  }
};
</script>
